import React, { useRef } from "react";
import { TbChevronRight } from "react-icons/tb";

const DocumentsStep = ({
  uploadedDocuments,
  onFileUpload,
  onRemoveDocument,
  onBack,
  onNextStep
}) => {
  const dropRef = useRef(null);

  const isImage = (type) => type.startsWith("image/");
  const isPDF = (type) => type === "application/pdf";

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const files = Array.from(e.dataTransfer.files);
    handleFiles(files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    dropRef.current.classList.add("drag-over");
  };

  const handleDragLeave = () => {
    dropRef.current.classList.remove("drag-over");
  };

  const handleFiles = async (files) => {
    const processedFiles = await Promise.all(
      files.map(async (file) => {
        const base64 = await convertToBase64(file);
        return {
          id: Date.now() + Math.random(),
          name: file.name,
          type: file.type,
          size: file.size,
          file,
          base64
        };
      })
    );
    onFileUpload(processedFiles);

  };

  const convertToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  return (
    <div className="step-content_">
      <h2 className="step-title">Documentos Requeridos</h2>
      <p className="step-subtitle">
        Sube los documentos necesarios para tu consulta
      </p>

      <div className="documents-info card_background">
        <p>
          Por favor sube los siguientes documentos (opcional pero recomendado):
        </p>
        <ul>
          <li>Documento de identificación (cédula, pasaporte)</li>
          <li>Carné de tu EPS o seguro médico</li>
          <li>Exámenes médicos recientes</li>
          <li>Historia clínica relevante</li>
          <li>Orden médica si aplica</li>
        </ul>
      </div>

      <div
        className="upload-box card_background"
        ref={dropRef}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
      >
        <div className="upload-icon">
          <i className="fas fa-cloud-upload-alt"></i>
        </div>
        <p>Arrastra tus documentos aquí o</p>
        <label htmlFor="file-upload" className="upload-btn">
          Seleccionar archivos
        </label>
        <input
          id="file-upload"
          type="file"
          multiple
          accept=".pdf,.jpg,.jpeg,.png"
          onChange={(e) => handleFiles(Array.from(e.target.files))}
          style={{ display: "none" }}
        />
        <p className="upload-hint">
          Formatos aceptados: PDF, JPG, PNG (Máx. 10MB por archivo)
        </p>
      </div>

      {uploadedDocuments.length > 0 && (
        <div className="uploaded-documents">
          <h3>Documentos subidos:</h3>
          <div className="documents-list">
            {uploadedDocuments.map((doc) => (
              <div key={doc.id} className="document-item">
                <div className="document-preview">
                  {isImage(doc.type) ? (
                    <img
                      src={doc.base64}
                      alt={doc.name}
                      className="document-thumbnail"
                    />
                  ) : isPDF(doc.type) ? (
                    <div className="pdf-preview">
                      <i className="far fa-file-pdf pdf-icon" />
                    </div>
                  ) : (
                    <div className="file-icon">
                      <i className="far fa-file" />
                    </div>
                  )}
                </div>

                <div className="document-info">
                  <div className="document-name">{doc.name}</div>
                  <div className="document-size">
                    {(doc.size / 1024).toFixed(1)} KB
                  </div>
                </div>

                {isPDF(doc.type) && (
                  <a
                    className="view-doc"
                    href={doc.base64}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver
                  </a>
                )}

                <button
                  className="remove-doc"
                  onClick={() => onRemoveDocument(doc.id)}
                >
                  <i className="fas fa-times" />
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="form-actions">
        <button className="back-btn" onClick={onBack}>
          Volver a datos del paciente
        </button>
        <button className="next-btn" onClick={onNextStep}>
          <span>Siguiente</span>
          <span style={{ marginRight: "-.5rem" }}>
            <TbChevronRight size={21} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default DocumentsStep;
